import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DomPurify from 'dompurify';
import { useAppDispatch } from '../../../../hooks/redux';
import { CustomMUIButton } from '../../../commons/buttons/CustomMUIButton';
import { ButtonClassNames, ModalVariants } from '../../../../models/Common';
import { modalSlice } from '../../../../store/reducers/ModalSlice';
import { ReactComponent as CheckIcon } from '../../../../assets/images/ArrowSaveEmail.svg';
import { ReactComponent as InfoIcon } from '../../../../assets/images/InfoOutlined.svg';
import { personalAccountRulesDocLink } from '../../../../constants/configuration';

interface IUserAccount {
  userName?: string;
  isVerified: boolean;
  userId?: number;
}

const defaultProps = {
  userName: undefined,
  userId: undefined,
};

export const UserAccount: FC<IUserAccount> = ({ userName, isVerified, userId }) => {
  const { t } = useTranslation();
  const sanitizer = DomPurify.sanitize;
  const dispatch = useAppDispatch();
  const { openModal } = modalSlice.actions;

  const handleConfirmMember = () => {
    dispatch(openModal({ modalVariants: ModalVariants.AcceptMembership }));
  };

  const handleDeleteFromMember = (id?: number) => {
    dispatch(
      openModal({
        modalVariants: ModalVariants.LeaveAccount,
        content: {
          accountId: String(id),
        },
      }),
    );
  };

  return (
    <div className="multi-account__user">
      <div className="multi-account__user__info">
        <div className="multi-account__user__info-name">
          <div className="multi-account__user__info-admin">{t('multiAccount.yourAdmin')}</div>
          <div className="multi-account__user__info-identity">{userName}</div>
        </div>
        <div>
          <div className="multi-account__user__info-competencies">{t('multiAccount.adminCompetencies')}</div>
          <ul className="multi-account__user__info-list">
            <li>{t('multiAccount.payForServices')}</li>
            <li>{t('multiAccount.changeServices')}</li>
            <li>{t('multiAccount.viewNotifications')}</li>
          </ul>
        </div>
      </div>
      <div className="multi-account__user__notice">
        {isVerified ? (
          <div className="multi-account__user__notice-status">
            <CheckIcon className="icon-check" />
            {t('multiAccount.accountPartOf')}
          </div>
        ) : (
          <div className="multi-account__user__notice-status">
            <InfoIcon className="icon-info" />
            {t('multiAccount.accountNotPartOf')}
          </div>
        )}
        <div className="multi-account__user__notice-actions">
          {!isVerified && (
            <CustomMUIButton
              label={t('buttons.accept')}
              handleClick={handleConfirmMember}
              className={ButtonClassNames.PrimaryFulfilled}
              isBold
            />
          )}
          <CustomMUIButton
            label={t('multiAccount.leaveAccounts')}
            handleClick={() => handleDeleteFromMember(userId)}
            className={ButtonClassNames.SecondaryOutlined}
            isBold
          />
        </div>
      </div>
      <p
        className="multi-account__user__terms"
        dangerouslySetInnerHTML={{
          __html: sanitizer(t('multiAccount.termsAndConditions', { rules: personalAccountRulesDocLink }), {
            ADD_ATTR: ['target'],
          }),
        }}
      />
    </div>
  );
};

UserAccount.defaultProps = defaultProps;
